export const DAILY_CPS_LIST = 'DAILY_CPS_LIST';
export const DAILY_CPS_LIST_SUCCESS = 'DAILY_CPS_LIST_SUCCESS';
export const DAILY_CPS_LIST_ERROR = 'DAILY_CPS_LIST_ERROR';

export const TLPS_LIST = 'TLPS_LIST';
export const TLPS_LIST_SUCCESS = 'TLPS_LIST_SUCCESS';
export const TLPS_LIST_ERROR = 'TLPS_LIST_ERROR';